import React, { FC } from 'react';
import {
  Body,
  Box,
  Flex,
  Glyph,
  Pill,
} from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { useFlowTools } from 'flowTools/useFlowTools';

type FlightUnavailableOverlayProps = {
  isBrokenFlow?: boolean;
  withOverlay?: boolean;
  withPillLabel?: boolean;
};

const OverlayPillContent: FC<{ isBrokenFlow: boolean }> = ({
  isBrokenFlow,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useFlowTools();

  return (
    <Flex alignItems="center" gap="2x_small">
      <Glyph category="UIActions" name="Block" size="small" color="neutral.0" />
      <Body
        weight="normal"
        type="small"
        color="neutral.0"
        sx={{ paddingTop: '2px' }}
      >
        {isBrokenFlow
          ? isMobile
            ? t('alternativeBrokenFlow.overlay.pill')
            : t('alternativeBrokenFlow.overlay.large.pill')
          : t('alternativeItinerary.nonIssuable.overlay.pill')}
      </Body>
    </Flex>
  );
};

const ItineraryUnavailableOverlay: FC<FlightUnavailableOverlayProps> = ({
  withOverlay = false,
  isBrokenFlow = false,
  withPillLabel = true,
  children,
}) => {
  return withOverlay ? (
    <Box>
      <Box
        sx={{
          position: 'relative',
        }}
      >
        {withPillLabel && (
          <Pill
            type="neutral"
            rounded
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 2,
              backgroundColor: 'neutral.80',
              width: 'max-content',
            }}
          >
            <OverlayPillContent isBrokenFlow={isBrokenFlow} />
          </Pill>
        )}
        <Box
          data-testid="itinerary-unavailable-overlay"
          style={{
            color: 'neutral.60',
            filter: 'grayscale(100%) opacity(90%) brightness(100%)',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  ) : (
    <Box>{children}</Box>
  );
};

export default ItineraryUnavailableOverlay;
